<div class="reply-label" *ngIf="replyToId">
  <span class="p5">Reply to:</span>
  <span class="p6">{{replyToLabel}}</span>
  <app-button
    icon="close"
    size="small"
    [style]="'link'"
    (onCLick)="onReplyCancel.emit()"
  >
  </app-button>
</div>
<div class="message-box">
  <app-input
    #input
    [placeholder]="placeholder"
    [(value)]="value"
    [inputGroup]="formGroup"
    [fieldName]="fieldName"
    [disabled]="disabled"
    [(invalid)]="isInvalid"
    [showError]="showError"
    (onInput)="checkErrors()"
  ></app-input>
  <app-button
    icon="send-white"
    size="medium"
    [disabled]="disabled || isInvalid || emptyField"
    [style]="'filled'"
    (click)="sendMessage()"
  >
  </app-button>
</div>
